import React, { useState } from "react";
import {
  FormGroup,
  Label,
  Button,
  Col,
  FormText,
  Input,
  Row,
} from "reactstrap";
import "../releases/row.css";
import { useTranslation } from "react-i18next";

const RowSelect = ({ values, key }) => {
  const { t } = useTranslation();
  const [error, setError] = useState(false);

  const validateUrl = (url) => {
    return url.match(
      /^(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
    );
  };

  const handlePlayClick = (id) => {
    const trArray = document.querySelectorAll('[id^="track_play_"]');
    trArray.forEach((audio) => {
      if ( !audio.paused && audio.id !== `track_play_${id}`){
          audio.pause();
      }
    });
  };

  const { previewFile, remove, index, manageData, previewFiles } = values;
  return (
    <>
      <div className="artistWrap" style={{ flexDirection: "column" }}>
        <div className="artistWrap" style={{ margin: "0", alignItems: 'flex-start' }}>
          <Col xs="4">
            <audio
              controls
              id={"track_play_" + index}
              controlsList="nodownload"
              onPlay={() => handlePlayClick(index)}
            >
              <source src={previewFile.url} type={"audio/mp3"} />
              {t("musicLinks.previewFilesRow.audioNotSupported")}
            </audio>
            {/* <Input
              type="text"
              name={`url`}
              value={previewFile.url}
              className={`${error ? "is-invalid" : ""}`}
              onChange={({ target: { name, value } }) => {
                if (value === "") {
                  setError(false);
                  return;
                }
                if (validateUrl(value) === null) {
                  setError(true);
                } else {
                  setError(false);
                }
                manageData(index, name, value);
              }}
            /> */}
          </Col>
          <Col xs="4">
            <Input
              type="text"
              name={`preview_file[${index}].artist_name`}
              disabled={true}
              defaultValue={previewFile.artist_name}
              onChange={({ target: { name, value } }) =>
                manageData(index, name, value)
              }
            />
          </Col>

          <Col xs="4">
            <Input
              type="text"
              name={`preview_file[${index}].track_name`}
              disabled={true}
              defaultValue={previewFile.track_name}
              onChange={({ target: { name, value } }) =>
                manageData(index, name, value)
              }
            />
          </Col>

          {/* <Col xs="2">
            <Button color={"danger"} onClick={() => remove(index)}>
              Remove{" "}
            </Button>
          </Col> */}
        </div>
      </div>
    </>
  );
};

const RowLabel = () => {
  const { t } = useTranslation();
  return (
    <Row className="artistWrap labelRow">
      <Col xs="4">{t("musicLinks.previewFilesRow.label.preview")}</Col>
      <Col xs="4">{t("musicLinks.previewFilesRow.label.artistName")}</Col>
      <Col xs="4">{t("musicLinks.previewFilesRow.label.trackName")}</Col>
      {/* <Col xs="2">Delete</Col>
      <Col xs="1"></Col> */}
    </Row>
  );
};

const PreviewFilesRow = ({ values }) => {
  let { previewFiles = [], remove, addNew, manageData } = values;
  const { t } = useTranslation();

  return (
    <>
      <FormGroup>
        <Label><b>{t("musicLinks.previewFilesRow.title")}</b></Label>
        <Row>
          <RowLabel />
        </Row>
        <Row>
          {previewFiles.map((previewFile, index) => {
            const itemVal = {
              index,
              previewFile,
              remove,
              manageData,
              previewFiles,
            };
            return <RowSelect values={itemVal} key={index} />;
          })}
        </Row>

        {/* <div>
          <Button
            color="primary"
            onClick={() =>
              addNew([
                ...previewFiles,
                {
                  url: "",
                  artist_name: "",
                  track_name: "",
                },
              ])
            }
          >
            Add another
          </Button>{" "}
        </div> */}
      </FormGroup>
    </>
  );
};

export default PreviewFilesRow;